import { useSelector } from 'react-redux';
import { selectElevatorFloorLabel } from '../services/selectors';

export const useElevatorFloorLabel = (floor: number) =>
    useSelector(appState =>
        selectElevatorFloorLabel(appState, {
            floor,
        }),
    );
